import * as React from "react";
import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import CloseIcon from "@mui/icons-material/Close";
import useIsMobile from "../hooks/useIsMobile";

export default function SwipeableTemporaryDrawer({
  isOpenDrawer,
  setIsOpenDrawer,
  children,
  module
}) {
  const isMobile = useIsMobile();
  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setIsOpenDrawer(open);
  };

  return (
    <div>
      <React.Fragment key={"right"}>
        <Button onClick={toggleDrawer(true)} />
        <SwipeableDrawer
          anchor={"right"}
          open={isOpenDrawer}
          onClose={toggleDrawer(false)}
          onOpen={toggleDrawer(true)}
        >
          <Box
            sx={{ width: isMobile?350 :480 }}
            role="presentation"
            //   onClick={toggleDrawer(anchor, false)}
            //   onKeyDown={toggleDrawer(anchor, false)}
          >
            <div className="p-4">
              <div className="w-100 d-flex justify-content-between">
                <p className="mb-0 align-self-center fs-5 fw-bolder text-color-theme">
                  {module} Filter
                </p>
                <span
                  className="text-color-theme "
                  onClick={toggleDrawer(false)}
                >
                  {" "}
                  <CloseIcon />
                </span>
              </div>
              <div className="mt-3" style={{height:"85vh"}}>{children}</div>
            </div>
          </Box>
        </SwipeableDrawer>
      </React.Fragment>
    </div>
  );
}
